import React from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../App.css";

const Home = () => {
  const navigate = useNavigate(); // Initialize useNavigate

  return (
    <div>
      {/* Header Section */}
      <div className="relative px-6 pt-14 lg:px-8">
        <div className="mx-auto max-w-4xl py-16 text-center">
          <h1 className="text-5xl font-bold text-dark mb-6">Discover What's Buzzing Around You</h1>
          <p className="text-lg text-muted mb-8">
            Explore trending events, exclusive offers, and promotions nearby. Your city's buzz in one place.
          </p>
          {/* Explore Button */}
          <div className="d-flex justify-content-center">
            <button
              className="btn btn-warning"
              onClick={() => navigate("/explore")} // Navigate to Explore route
            >
              Explore
            </button>
          </div>
        </div>
      </div>

      {/* Trending Events Section */}
      <div className="container py-5">
        <h2 className="text-center mb-4">Trending Events</h2>
        <div className="row">
          {/* Event 1: Concert */}
          <div className="col-md-4">
            <div className="card mb-4 shadow-sm">
              <img
                src={`${process.env.PUBLIC_URL}/assets/concert.jpg`}
                className="card-img-top"
                alt="Rock Concert"
              />
              <div className="card-body">
                <h5 className="card-title">Rock Concert: The XYZ Band Live</h5>
                <p className="card-text">
                  Get ready to rock out with XYZ Band as they perform their greatest hits live on stage. Don’t miss this electrifying night!
                </p>
                <p><strong>Date:</strong> Saturday, January 20, 2025</p>
                <p><strong>Location:</strong> City Music Hall</p>
                <a href="#" className="btn btn-warning">
                  Learn More
                </a>
              </div>
            </div>
          </div>

          {/* Event 2: Wine Tasting */}
          <div className="col-md-4">
            <div className="card mb-4 shadow-sm">
              <img
                src={`${process.env.PUBLIC_URL}/assets/wine-tasting.jpg`}
                className="card-img-top"
                alt="Wine Tasting"
              />
              <div className="card-body">
                <h5 className="card-title">Wine Tasting: Explore Fine Flavors</h5>
                <p className="card-text">
                  Join us for an evening of exquisite wines and expert pairings. A must-attend event for all wine enthusiasts.
                </p>
                <p><strong>Date:</strong> Friday, January 26, 2025</p>
                <p><strong>Location:</strong> Vineyard Lounge</p>
                <a href="#" className="btn btn-warning">
                  Learn More
                </a>
              </div>
            </div>
          </div>

          {/* Event 3: DJ Night */}
          <div className="col-md-4">
            <div className="card mb-4 shadow-sm">
              <img
                src={`${process.env.PUBLIC_URL}/assets/dj-night.jpg`}
                className="card-img-top"
                alt="DJ Night"
              />
              <div className="card-body">
                <h5 className="card-title">DJ Night: Club Beats</h5>
                <p className="card-text">
                  Dance the night away with top DJs spinning the hottest tracks. A perfect way to kick off your weekend.
                </p>
                <p><strong>Date:</strong> Friday, February 2, 2025</p>
                <p><strong>Location:</strong> The Groove Club</p>
                <a href="#" className="btn btn-warning">
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Offers Section */}
      <div className="bg-dark text-white py-5">
        <div className="container">
          <h2 className="text-center mb-4">Exclusive Offers</h2>
          <div className="row">
            {/* Offer 1: Coffee + Pancake Promo */}
            <div className="col-md-4">
              <div className="card text-dark mb-4">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/coffee.jpg`}
                  className="card-img-top"
                  alt="Coffee + Pancake Promo"
                />
                <div className="card-body">
                  <h5 className="card-title">Coffee + Pancake Promo</h5>
                  <p className="card-text">
                    Start your day with a delicious combo! Enjoy a cup of freshly brewed coffee and fluffy pancakes for just $5.
                  </p>
                  <p><strong>Valid:</strong> Daily, 7 AM - 11 AM</p>
                  <a href="#" className="btn btn-warning">
                    View Offer
                  </a>
                </div>
              </div>
            </div>

            {/* Offer 2: Dinner for Two */}
            <div className="col-md-4">
              <div className="card text-dark mb-4">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/dinner-for-two.jpg`}
                  className="card-img-top"
                  alt="Dinner for Two"
                />
                <div className="card-body">
                  <h5 className="card-title">Dinner for Two</h5>
                  <p className="card-text">
                    Enjoy a romantic evening with our special dinner-for-two package. Includes an appetizer, main course, and dessert.
                  </p>
                  <p><strong>Price:</strong> $50 per couple</p>
                  <p><strong>Available:</strong> Friday & Saturday Evenings</p>
                  <a href="#" className="btn btn-warning">
                    View Offer
                  </a>
                </div>
              </div>
            </div>

            {/* Offer 3: Happy Hour */}
            <div className="col-md-4">
              <div className="card text-dark mb-4">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/happy-hour.jpg`}
                  className="card-img-top"
                  alt="Happy Hour"
                />
                <div className="card-body">
                  <h5 className="card-title">Happy Hour</h5>
                  <p className="card-text">
                    Unwind after work with our Happy Hour specials! Get 50% off all drinks from 5 PM to 7 PM.
                  </p>
                  <p><strong>When:</strong> Monday to Friday</p>
                  <a href="#" className="btn btn-warning">
                    View Offer
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Happening Today Section */}
      <div className="py-5 bg-light">
        <div className="container">
          {/* Section Title */}
          <h2 className="text-center mb-4 text-dark">Happening Today</h2>
          <p className="text-center text-muted mb-5">
            Don’t miss out on these events and offers happening in your area today!
          </p>

          {/* Highlights Section */}
          <div className="row mb-5">
            {/* Highlight 1 */}
            <div className="col-md-4">
              <div className="card shadow-sm">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/concert.jpg`}
                  className="card-img-top"
                  alt="Concert"
                />
                <div className="card-body text-center">
                  <h5 className="card-title">Live Concert</h5>
                  <p className="card-text text-muted">
                    Enjoy a rocking night with the best live music in town.
                  </p>
                  <p className="text-muted"><strong>Tonight, 8 PM</strong></p>
                </div>
              </div>
            </div>

            {/* Highlight 2 */}
            <div className="col-md-4">
              <div className="card shadow-sm">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/wine-tasting.jpg`}
                  className="card-img-top"
                  alt="Food Festival"
                />
                <div className="card-body text-center">
                  <h5 className="card-title">Food Festival</h5>
                  <p className="card-text text-muted">
                    Savor delicious cuisines from around the world.
                  </p>
                  <p className="text-muted"><strong>All Day Today</strong></p>
                </div>
              </div>
            </div>

            {/* Highlight 3 */}
            <div className="col-md-4">
              <div className="card shadow-sm">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/dj-night.jpg`}
                  className="card-img-top"
                  alt="DJ Night"
                />
                <div className="card-body text-center">
                  <h5 className="card-title">DJ Night</h5>
                  <p className="card-text text-muted">
                    Dance the night away with the hottest tracks.
                  </p>
                  <p className="text-muted"><strong>Tonight, 10 PM</strong></p>
                </div>
              </div>
            </div>
          </div>

          {/* Embedded Map */}
          <div className="row">
            <div className="col-md-12">
              <iframe
                title="Happening Today Map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.835434509164!2d-122.40109738467746!3d37.7873591797569!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80858064ebfa8e1b%3A0xe4449ab29c25fca5!2sSan+Francisco%2C+CA!5e0!3m2!1sen!2sus!4v1616176649083!5m2!1sen!2sus"
                width="100%"
                height="450"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>
          </div>

          {/* Call-to-Action */}
          <div className="text-center mt-4">
            <button
              className="btn btn-warning px-5 py-3"
              onClick={() => navigate("/explore")} // Navigate to Explore route
            >
              Explore
            </button>
          </div>
        </div>
      </div>



    </div>
  );
};

export default Home;
